import * as React from 'react';
import { escapeRegExp } from 'lodash';

const Highlight = ({ text = '', highlight = '' }) => {
  if (!highlight.trim()) {
    return <span>{text}</span>;
  }
  const regex = new RegExp(`(${escapeRegExp(highlight)})`, 'gi'); // regex expression to run a global case sensitive check for highlight string
  const parts = text.split(regex);

  // returning jsx to use this as a child react node
  return (
    <>
      {parts.map((part, index) =>
        regex.test(part) ? (
          <span
            key={index}
            style={{ backgroundColor: '#fff200', height: '2px' }}
          >
            {part}
          </span>
        ) : (
          <span key={index}>{part}</span>
        )
      )}
    </>
  );
};

export default Highlight;
